import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SEO from '@/components/feature/SEO';
import HeroSection from './components/HeroSection';
import FeaturedComics from './components/FeaturedComics';
import CategorySection from './components/CategorySection';
import LatestUpdates from './components/LatestUpdates';
import { Link } from 'react-router-dom';

const homeJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '汗汗漫画',
  url: 'https://hanhancomic.com',
  description: '汗汗漫画主打下拉式漫画连续阅读，滚动观看不间断，漫画下拉即可加载全集，免费流畅观看各类漫画，感受全新阅读方式。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://hanhancomic.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

export default function Home() {
  return (
    <>
      <SEO
        title="汗汗漫画-下拉式漫画连续阅读滚动观看 | 漫画下拉全集免费看 | 在线看漫画流畅丝滑体验"
        description="汗汗漫画主打下拉式漫画连续阅读，滚动观看不间断，漫画下拉即可加载全集，免费流畅观看各类漫画，感受全新阅读方式。"
        keywords="汗汗漫画,下拉式漫画,连续阅读,滚动阅读,漫画下拉,在线阅读,免费看漫画,流畅阅读,漫画体验,阅读方式"
        canonicalUrl="https://hanhancomic.com"
        ogImage="https://readdy.ai/api/search-image?query=Chinese%20comic%20reading%20platform%20warm%20vibrant%20atmosphere%20manga%20books%20flying%20colorful%20artistic%20design%20modern%20clean%20aesthetic&width=1200&height=630&seq=og-home-hanhan&orientation=landscape"
        jsonLd={homeJsonLd}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main>
          <HeroSection />
          <FeaturedComics />
          <CategorySection />

          <section className="py-14 md:py-20 bg-background-100">
            <div className="max-w-7xl mx-auto px-4 md:px-6 text-center">
              <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-4">
                下拉式阅读，体验丝滑流畅
              </h2>
              <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto leading-relaxed mb-8">
                汗汗漫画采用创新的下拉式漫画连续阅读技术，告别传统翻页模式。只需向下滚动，漫画内容即可无缝加载，全集一气呵成，带给你前所未有的流畅阅读体验。
              </p>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div className="p-6 bg-background-50 rounded-lg border border-background-200/60">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mx-auto mb-4">
                    <i className="ri-scroll-to-bottom-line text-2xl"></i>
                  </div>
                  <h3 className="text-base font-semibold text-foreground-900 mb-2">下拉阅读</h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">向下滚动即可加载下一话，无需点击翻页按钮，阅读体验行云流水。</p>
                </div>
                <div className="p-6 bg-background-50 rounded-lg border border-background-200/60">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mx-auto mb-4">
                    <i className="ri-flashlight-line text-2xl"></i>
                  </div>
                  <h3 className="text-base font-semibold text-foreground-900 mb-2">极速加载</h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">采用先进的预加载技术，确保漫画页面秒开，绝不让等待打断你的阅读节奏。</p>
                </div>
                <div className="p-6 bg-background-50 rounded-lg border border-background-200/60">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 mx-auto mb-4">
                    <i className="ri-smartphone-line text-2xl"></i>
                  </div>
                  <h3 className="text-base font-semibold text-foreground-900 mb-2">全平台适配</h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">无论是电脑、平板还是手机，都能享受完美适配的阅读界面，随时随地畅快阅读。</p>
                </div>
              </div>
            </div>
          </section>

          <LatestUpdates />

          <section className="py-14 md:py-20 bg-primary-500">
            <div className="max-w-7xl mx-auto px-4 md:px-6 text-center">
              <h2 className="text-2xl md:text-3xl font-heading text-background-50 mb-4">
                开始你的漫画之旅
              </h2>
              <p className="text-sm md:text-base text-background-50/80 max-w-xl mx-auto mb-8 leading-relaxed">
                上千部优质漫画等你来发现，现在就加入汗汗漫画，体验全新的阅读方式！
              </p>
              <Link
                to="/category/rexue"
                className="inline-flex items-center gap-2 px-8 py-3 bg-background-50 text-primary-600 rounded-full font-semibold text-sm hover:bg-background-100 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                立即探索 <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
              </Link>
            </div>
          </section>
        </main>

        <Footer />
        <ScrollToTop />
      </div>
    </>
  );
}